import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'edit-learn-category',
    templateUrl: './edit-learn-category.component.html',
    styleUrls: ['./edit-learn-category.component.scss'],
    standalone: false
})

export class EditLearnCategoryComponent implements OnInit
{
  action: string;
  dialogTitle;
  name;
  id;
  chosenColor;


    constructor(
        public dialogRef: MatDialogRef<EditLearnCategoryComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    )
    {
        this.action = data.action;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = 'edit_learn_category';
            this.name = data.type;
        }
        else
        {
            this.dialogTitle = 'new_learn_category';
        }
    }

    ngOnInit()
    {
    }

  onSettingsChange(event) {
    this.chosenColor = event.bg;
  }
}
